import { MAX_PICKER_SCORE } from '../scoreBounds'
import './ScorePicker.css'

interface ScorePickerProps {
  label: string
  value: number
  onChange: (value: number) => void
}

function ScorePicker({ label, value, onChange }: ScorePickerProps) {
  const increment = () => onChange(Math.min(value + 1, MAX_PICKER_SCORE))
  const decrement = () => onChange(Math.max(value - 1, 0))

  return (
    <div className="score-picker">
      <button
        className="score-picker__btn"
        onClick={increment}
        aria-label={`Increase ${label} score`}
      >
        +
      </button>
      <span className="score-picker__value">{value}</span>
      <button
        className="score-picker__btn"
        onClick={decrement}
        aria-label={`Decrease ${label} score`}
      >
        −
      </button>
    </div>
  )
}

export default ScorePicker
